import { useState } from "react";
import { TerminalLine } from "../components/terminal/TerminalLine";
import { useAuditStream } from "../components/ai/useAuditStream";

type Period = "weekly" | "monthly";

export function AuditPage() {
  const [period, setPeriod] = useState<Period>("weekly");
  const { text, isLoading, error, run } = useAuditStream({ session: period });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <TerminalLine prompt accent>audit</TerminalLine>
      
      <div style={{ fontSize: "0.75rem", color: "var(--fg-dim)", marginBottom: "0.5rem" }}>
        Run a retrospective audit of your tracked habits, journal summaries, and XP milestones.
      </div>

      <div style={{ display: "flex", gap: "0.5rem" }}>
        {(["weekly", "monthly"] as Period[]).map((p) => (
          <button
            key={p}
            type="button"
            className={period === p ? "shukan-btn shukan-btn-primary" : "shukan-btn"}
            onClick={() => setPeriod(p)}
          >
            {p} audit
          </button>
        ))}
        <button
          type="button"
          className="shukan-btn shukan-btn-primary"
          onClick={() => void run()}
          disabled={isLoading}
          style={{ marginLeft: "auto" }}
        >
          {isLoading ? "Auditing..." : "$ generate"}
        </button>
      </div>

      <div
        style={{
          border: "1px solid var(--border)",
          padding: "1rem",
          backgroundColor: "var(--bg-elevated)",
          fontFamily: "JetBrains Mono, monospace",
          fontSize: "0.85rem",
          minHeight: "15rem",
          whiteSpace: "pre-wrap",
          lineHeight: 1.6,
          color: "var(--fg)",
        }}
      >
        {isLoading && !text && (
          <div style={{ color: "var(--accent)" }} className="shukan-prompt-cursor">
            $ assembling historical data and triggering coach audit...
          </div>
        )}
        {error && <div style={{ color: "var(--danger)" }}>! audit failed: {error}</div>}
        {!isLoading && !error && !text && (
          <div style={{ color: "var(--fg-dim)" }}>
            $ click "$ generate" to execute the local {period} AI auditor.
          </div>
        )}
        {text}
      </div>
    </div>
  );
}
